<mat-grid-list [cols]="gridCols" rowHeight="130px">
  <div class="container">
    <div [hidden]="submitted">
      <form (ngSubmit)="onSubmit()" #Form="ngForm">
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="carline"
              >Carline
              <!-- <mat-radio-group>
                <mat-radio-button value="1">Text Search</mat-radio-button>
                <mat-radio-button value="2" class="custom-radio"
                  >Substring Search</mat-radio-button -->

              <!-- </mat-radio-group>-->
            </label>
            <mat-select
              class="form-control custom-select"
              [(ngModel)]="model.carline"
              [ngModelOptions]="{ standalone: true }"
              #carlines="ngModel"
              (valueChange)="onCarlineSelected($event)"
              multiple
            >
              <!-- Add options here -->
              <mat-option *ngFor="let carline of carline" [value]="carline.id">
                {{ carline.id }}
              </mat-option>
            </mat-select>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="workstation"
              >Workstation<mat-icon
                matTooltip="Please select Carline"
                class="info-icon"
                >info</mat-icon
              >
            </label>
            <mat-select
              class="form-control custom-select"
              [(ngModel)]="model.workstation"
              [ngModelOptions]="{ standalone: true }"
              #workstation="ngModel"
              [disabled]="!model.carline || model.carline.length === 0"
              multiple
            >
              <mat-option
                *ngFor="let workstation of workstations"
                [value]="workstation.id"
                >{{ workstation.id }}</mat-option
              >
            </mat-select>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="selection"
              >Selection of results<mat-icon
                matTooltip="Please Enter the result list you want to search. 
                The options has searching for following data, 
                images: ['png', 'jpg', 'jpeg', 'bmp', 'tiff']

                html: ['html', 'htm', 'xhtml'],

                text: ['txt', 'doc', 'log', 'docx', 'ppt', 'pptx', 'xls',
                'xlsx', 'pdf', 'xml', 'json'],

                csv: ['csv'],

                other files are stored under other file type
                "
                class="info-icon"
                >info</mat-icon
              ></label
            >
            <mat-select
              class="form-control custom-select"
              [(ngModel)]="model.selection"
              [ngModelOptions]="{ standalone: true }"
              #ordertype="ngModel"
            >
              <mat-option value="" disabled selected hidden
                >selection of results</mat-option
              >
              <!-- Add options here -->
              <mat-option *ngFor="let item of selection" [value]="item.id">{{
                item.name
              }}</mat-option>
            </mat-select>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="ordertype">Ordertype</label>
            <mat-select
              class="form-control custom-select"
              [(ngModel)]="model.ordertype"
              [ngModelOptions]="{ standalone: true }"
              #ordertype="ngModel"
            >
              <mat-option value="" disabled selected hidden
                >ordertype</mat-option
              >
              <!-- Add options here -->
              <mat-option
                *ngFor="let orderType of ordertypes"
                [value]="orderType.id"
              >
                {{ orderType.id }}
              </mat-option>
            </mat-select>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="orderident">
              Orderident
              <mat-icon
                matTooltip="Please enter one or more Orderident values separated by commas, or import a CSV file."
                class="info-icon"
              >
                info
              </mat-icon>
            </label>

            <input
              type="text"
              class="form-control custom-select"
              [(ngModel)]="model.orderident"
              [ngModelOptions]="{ standalone: true }"
              #orderident="ngModel"
              placeholder="orderident"
              [disabled]="hasCsvValues('orderident')"
            />

            <div class="row mt-2">
              <div class="col-4">
                <app-select-file
                  type="button"
                  class="w-100"
                  prompt="Import"
                  (fileParsed)="handleCSVContent($event, 'orderident')"
                  [tooltip]="getCsvTooltipText('orderident')"
                  [disabled]="hasManualValue('orderident')"
                >
                </app-select-file>
              </div>

              <div class="col-4">
                <button
                  type="button"
                  class="btn-primary nowrap w-100 btn-import"
                  matTooltip="View the Orderident values imported from CSV."
                  [disabled]="!hasCsvValues('orderident')"
                  (click)="
                    openCsvValuesDialog('Orderident', csvValues.orderident)
                  "
                >
                  View
                </button>
              </div>
              <div class="col-4">
                <button
                  type="button"
                  class="btn-primary nowrap w-100 btn-import"
                  matTooltip="Clear the Orderident values."
                  [disabled]="
                    !hasCsvValues('orderident') && !hasManualValue('orderident')
                  "
                  (click)="clearCsvValues('orderident')"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="file"
              >Filename
              <mat-icon
                matTooltip="Please enter one or more filenames the files had in the corresponding Zipfile, separated by commas, or import a CSV file."
                class="info-icon"
                >info
              </mat-icon>
            </label>
            <input
              type="text"
              class="form-control custom-select"
              [(ngModel)]="model.file"
              [ngModelOptions]="{ standalone: true }"
              #file="ngModel"
              placeholder="filename"
            />

            <div class="row mt-2">
              <div class="col-4">
                <app-select-file
                  type="button"
                  class="w-100"
                  prompt="Import"
                  (fileParsed)="handleCSVContent($event, 'file')"
                  [tooltip]="getCsvTooltipText('file')"
                  [disabled]="hasManualValue('file')"
                >
                </app-select-file>
              </div>

              <div class="col-4">
                <button
                  type="button"
                  class="btn-primary nowrap w-100 btn-import"
                  matTooltip="View the Filename values imported from CSV."
                  [disabled]="!hasCsvValues('file')"
                  (click)="openCsvValuesDialog('File', csvValues.file)"
                >
                  View
                </button>
              </div>
              <div class="col-4">
                <button
                  type="button"
                  class="btn-primary nowrap w-100 btn-import"
                  matTooltip="Clear the Filename values."
                  [disabled]="!hasCsvValues('file') && !hasManualValue('file')"
                  (click)="clearCsvValues('file')"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="filename"
              >OriginalFilename
              <mat-icon
                matTooltip="Please enter one or more original filenames of the Zip file or single file separated by commas, or import a CSV file."
                class="info-icon"
                >info
              </mat-icon>
            </label>
            <input
              type="text"
              class="form-control custom-select"
              [(ngModel)]="model.originalFilename"
              [ngModelOptions]="{ standalone: true }"
              #filename="ngModel"
              placeholder="originalFilename"
            />
            <div class="row mt-2">
              <div class="col-4">
                <app-select-file
                  type="button"
                  class="w-100"
                  prompt="Import"
                  (fileParsed)="handleCSVContent($event, 'originalFilename')"
                  [tooltip]="getCsvTooltipText('originalFilename')"
                  [disabled]="hasManualValue('originalFilename')"
                >
                </app-select-file>
              </div>

              <div class="col-4">
                <button
                  type="button"
                  class="btn-primary nowrap w-100 btn-import"
                  matTooltip="View the original filenames values imported from CSV."
                  [disabled]="!hasCsvValues('originalFilename')"
                  (click)="
                    openCsvValuesDialog(
                      'Original Filename',
                      csvValues.originalFilename
                    )
                  "
                >
                  View
                </button>
              </div>
              <div class="col-4">
                <button
                  type="button"
                  class="btn-primary nowrap w-100 btn-import"
                  matTooltip="Clear the original filenames values."
                  [disabled]="
                    !hasCsvValues('originalFilename') &&
                    !hasManualValue('originalFilename')
                  "
                  (click)="clearCsvValues('originalFilename')"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div
            class="from-control custom-div"
            style="align-self: start !important"
          >
            <label class="grayed-label"> Date Range</label>
            <app-date-range-picker
              class="from control custom-div"
              (dateRangeSelected)="handleDateRangeSelected($event)"
            >
            </app-date-range-picker>
          </div> </mat-grid-tile
        ><mat-grid-tile>
          <div class="form-group">
            <label class="grayed-label" for="filedisplaymode">
              File Display Mode
              <mat-icon
                matTooltip="Select which filename should be displayed.&#10;&#10;Default: Display Filename.&#10;&#10;Select 'Original Filename' only if the selected plant does not contain zip files in the process.&#10;&#10;"
                class="info-icon"
                >info</mat-icon
              >
            </label>
            <mat-select
              class="form-control custom-select"
              [(ngModel)]="fileDisplayMode"
              [ngModelOptions]="{ standalone: true }"
              name="filedisplaymode"
              (selectionChange)="onFileDisplayModeChange($event.value)"
              #filedisplaymode="ngModel"
              required
            >
              <mat-option value="displayFileName">Display Filename</mat-option>
              <mat-option value="displayOriginalFilename"
                >Display Original Filename</mat-option
              >
            </mat-select>
          </div>
        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile>
          <button type="button" class="btn-search" (click)="onSearch()">
            <i class="fa-solid fa-magnifying-glass white-icon"></i
            ><span> Search</span>
          </button>
        </mat-grid-tile>
        <mat-grid-tile>
          <button type="button" class="btn-search" (click)="clearFilter()">
            <i class="fa-solid fa-delete-left white-icon"></i
            ><span> Clear Filter</span>
          </button>
        </mat-grid-tile>
      </form>
    </div>
  </div>
</mat-grid-list>
<app-alert-info></app-alert-info>
